import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { heroTestimonials } from '../data/salesData';
export function HeroTestimonials() {
  return <section className="border-b border-[var(--olive)]/30 py-12" data-id="element-133" data-mp="y17bo00wcn50">
      <div className="mx-auto max-w-6xl px-4" data-id="element-134" data-mp="xznrhyc4drxy">
        <div className="grid gap-5 md:grid-cols-3" data-id="element-135" data-mp="tzvm1ui0w1wt">
          {heroTestimonials.map(t => <TestimonialCard key={t.name} testimonial={t} showLocation={false} data-id="element-136" data-mp="p097nhqgkfmf" />)}
        </div>
      </div>
    </section>;
}